import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const Features = () => {
  const { t } = useTranslation('features');

  return (
    <section id="features" className={theme.section + ' bg-background-primary mb-16'}>
      {/* Decorative blurred overlays */}
      <div
        aria-hidden="true"
        className="absolute inset-0 h-max w-full m-auto grid grid-cols-2 -space-x-52 opacity-20"
      >
        <div className="blur-[106px] h-56 bg-gradient-to-br from-[#6D9773] to-[#0C3B2E]"></div>
        <div className="blur-[106px] h-32 bg-gradient-to-r from-[#6D9773] to-[#0C3B2E]"></div>
      </div>

      <div className={theme.container}>
        <div className="md:w-2/3 lg:w-1/2 mt-8">
          <h2 className={theme.text.h1}>{t('title')}</h2>
          <p className={theme.text.body}>{t('description')}</p>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {/* AI-Powered Animation */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/ai-svgrepo-com.svg" alt={t('features.ai.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.ai.title')}</h5>
                <p className="text-white text-base leading-relaxed">
                  {t('features.ai.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Upload Process */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/photo-camera-photograph-svgrepo-com.svg" alt={t('features.easyToUse.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.easyToUse.title')}</h5>
                <p className="text-white text-base leading-relaxed">
                  {t('features.easyToUse.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Privacy Protection */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/lock-keyhole-svgrepo-com.svg" alt={t('features.privacy.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.privacy.title')}</h5>
                <p className="text-white text-base leading-relaxed">
                  {t('features.privacy.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Fast Creation */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/rocket-2-svgrepo-com.svg" alt={t('features.quality.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.quality.title')}</h5>
                <p className="text-white text-base leading-relaxed">
                  {t('features.quality.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Sharing */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/heart-shine-svgrepo-com.svg" alt={t('features.sharing.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.sharing.title')}</h5>
                <p className="text-white text-base leading-relaxed">
                  {t('features.sharing.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Payment */}
          <div className="rounded-lg bg-[#6D9773] border border-white/20 p-6">
            <div className="relative space-y-3 py-4 px-5">
              <div className="flex justify-center">
                <img src="/icons/payment-card-svgrepo-com.svg" alt={t('features.payment.title')} className="w-12 h-12 invert brightness-0" />
              </div>
              <div className="space-y-2 text-center">
                <h5 className="text-white text-lg font-semibold">{t('features.payment.title')}</h5>
                <p className="text-white/90 text-base leading-relaxed">
                  {t('features.payment.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;